module.exports = __webpack_public_path__ + "static/img/portail.96b002c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/entreprise/portail.png
// module id = uP8l
// module chunks = 0